import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";

const MySwal = withReactContent(Swal)

const OdaberiEkipuPlayoffModal = (props) => {
    const {
        toggle,
        isOpen,
        constituents,
        setConstituents
    } = props;

    const [chosenTeam, setChosenTeam] = useState("");
    const [validationFailed, setValidationFailed] = useState(false)
    let options = props.allTeams.map((singleTeam) => {
        return {
            label: (singleTeam.surname ? (singleTeam.name + " " + singleTeam.surname) : ((singleTeam.shortName ? singleTeam.shortName : singleTeam.name))),
            value: singleTeam
        }
    })

    options.unshift(
        {
            label: "?",
            value: null
        },
        {
            label: "***PRAZAN TIM***",
            value: {
                name: "***PRAZAN TIM***", 
                shortName: "***PRAZAN TIM***",
                _id: "000000000000000000000000"
            }  
        }
    )

    useEffect(() => {
    }, [])


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Odaberi ekipu
            </ModalHeader>
            <ModalBody>
                <Select
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={chosenTeam}
                    styles={{
                        control: styles => ({
                            ...styles,
                            borderColor: (validationFailed && chosenTeam === "") ? 'red' : styles.borderColor,
                            '&:hover': {
                                borderColor: (validationFailed && chosenTeam === "") ? 'red' : styles['&:hover'].borderColor
                            }
                        })
                    }}
                    onChange={(data) => {
                        setChosenTeam(data)
                    }}
                    name='clear'
                    options={options}
                    isClearable={false}
                />
            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            if (chosenTeam === "") {
                                setValidationFailed(true)
                                return;
                            }
                            let newGames = [...props.games];
                            let oldTeam = newGames[props.indexRound][props.gameIndex].teams[props.teamIndex];
                            newGames[props.indexRound][props.gameIndex].teams[props.teamIndex] = chosenTeam.value;
                            props.setGames([...newGames]);
                            let newTeams = [...props.allTeams].filter((singleTeam) => {
                                return singleTeam._id !== chosenTeam?.value?._id;
                            })
                            if (oldTeam && oldTeam._id) {
                                newTeams.push(oldTeam);
                            }
                            props.setAllTeams([...newTeams]);
                            setChosenTeam("");
                            props.toggle();

                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odaberi</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default OdaberiEkipuPlayoffModal;